module.exports = __webpack_public_path__ + "media/images/samples/home/top-n-1-389ca2cd47722ea9c3a1370e77647c9b.png";